import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { setContext } from "apollo-link-context";
import { createUploadLink } from "apollo-upload-client";

// Cache implementation
const cache = new InMemoryCache();

const uploadLink = createUploadLink({
  uri: `${process.env.VUE_APP_ADMIN_URL}/graphql`
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("user_token");
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ""
    }
  };
});

// Create the apollo client
const apolloClient = new ApolloClient({
  link: authLink.concat(uploadLink),
  cache,
  defaultOptions: {
    query: { fetchPolicy: "no-cache" },
    watchQuery: { fetchPolicy: "no-cache" }
  }
});

export default apolloClient;
